export default __webpack_public_path__ + "static/media/1-ThroughThePohutukawa.1802cebe.jpeg";